<template>
  <div class="custom-review-submit container">
    <div class="borrower-review" v-for="(borrower, borrower_i) in $store.state.borrowers" :key="'borrower_' + borrower_i">
      <legend>
        {{ borrower.FirstName.value }} {{ borrower.LastName.value }}
      </legend>
      <template v-for="(section, section_i) in $store.state.form.data.FormStructure.Sections">
        <div v-for="(subsection, subsection_i) in $store.state.form.data.FormStructure.Sections[section_i].Subsections" :key="'section_' + section_i + '_' + subsection_i">
          <div class="section-review" v-if="borrower_i == 0 || $store.getters.getSectionBorrowerScope(section.Id)">
            <button type="button" class="btn-default-outline" @click="onEdit($event, subsection.Page, borrower_i)">
              <icon :icon="['far', 'pencil']" />
            </button>
            <label>{{ subsection.Name }}</label>
            <template v-for="(page, page_i) in $store.state.formDefault.inputFields">
              <template v-if="subsection.Page == page.Id">
                <template v-if="$store.getters.isPageComplete(page.Id, borrower.Id)">
                  <div class="field-review" v-for="field in pageFields(borrower, page)" :key="field.Field.Id + '_' + field.Suffix">
                    <b>{{ field.Field.Text }}</b>{{ ': ' + formatSaveData(borrower, field.Field, field.Suffix) }}
                  </div>
                </template>
                <template v-else>
                  <div :key="'page_' + page_i + '_incomplete'">
                    - INCOMPLETE -
                  </div>
                </template>
              </template>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomReviewSubmit',
  props: {
    data: Object
  },
  data: () => {
    return {
      fieldSuffixes: ['', "__0", "__1", "__2", "__3", "__4", "__5", "__6", "__7", "__8", "__9", "__10", "__11", "__12", "__13", "__14", "__15", "__16", "__17", "__18", "__19", "__20", "__21", "__22", "__23", "__24", "__25", "__26", "__27", "__28", "__29", "__30", "__31", "__32"]
    }
  },
  methods: {
    onEdit: function(evt, section, index) {
      // Set borrower
      const prevBorrowerID = this.$store.state.borrowerid
      this.$store.commit('becomeBorrower', index)
      const newBorrowerID = this.$store.state.borrowerid
      if (prevBorrowerID !== newBorrowerID) this.$root.$emit('borrower:change')

      // Set page
      this.$store.dispatch('navGo', section)
      this.$root.$emit('update:sectionid')
      this.$root.$emit('update:pageid')
    },
    addSuffixToId: function (id, suffix) {
      // Janky AF but this is how the data is stored
      if (typeof id !== 'string')
        id = ''

      var index = -1

      if ((index = id.indexOf('__first')) !== -1)
        return id.substring(0, index) + suffix + '__first'
      else if ((index = id.indexOf('__middle')) !== -1)
        return id.substring(0, index) + suffix + '__middle'
      else if ((index = id.indexOf('__last')) !== -1)
        return id.substring(0, index) + suffix + '__last'
      else if ((index = id.indexOf('__suffix')) !== -1)
        return id.substring(0, index) + suffix + '__suffix'
      else if ((index = id.indexOf('__address_1')) !== -1)
        return id.substring(0, index) + suffix + '__address_1'
      else if ((index = id.indexOf('__address_2')) !== -1)
        return id.substring(0, index) + suffix + '__address_2'
      else if ((index = id.indexOf('__city')) !== -1)
        return id.substring(0, index) + suffix + '__city'
      else if ((index = id.indexOf('__state')) !== -1)
        return id.substring(0, index) + suffix + '__state'
      else if ((index = id.indexOf('__zip')) !== -1)
        return id.substring(0, index) + suffix + '__zip'
      else
        return id + suffix
    },
    formatSaveData: function (borrower, field, suffix) {
      var data = this.$store.state.saveData[borrower.Id][this.addSuffixToId(field.Id, suffix)]

      if (data === true || data === 'true')
        data = 'Yes'
      if (data === false || data === 'false')
        data = 'No'

      return data
    },
    pageFields: function (borrower, page) {
      var fields = []

      for (var i = 0; i < this.fieldSuffixes.length; i++) {
        var suffix = this.fieldSuffixes[i]

        for (var j = 0; j < (page.Inputs || []).length; j++) {
          var field = page.Inputs[j]
          var fieldValue = (this.$store.state.saveData[borrower.Id] || {})[this.addSuffixToId(field.Id, suffix)]

          if (fieldValue !== '' && fieldValue !== null && fieldValue !== undefined) {
            if (field.Visibility === 0 || field.Visibility === 2) {
              fields.push({ Field: field, Suffix: suffix })
            }
          }
        }
      }

      return fields
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.custom-review-submit {
  .borrower-review {
    legend {
      font-size: 18px;
      font-weight: 400;
    }
  }

  .section-review {
    min-height: 2rem;
    margin-bottom: 1rem;
    line-height: normal;
    font-size: 16px;
    border-radius: 8px;
    background-color: #f2f2f2;
    padding: 20px;

    label {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 2px;
    }

    button {
      float: right;
    }

    .field-review {
      margin-bottom: 0.5rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
